module.exports = __webpack_public_path__ + "img/st.3709ef58.webp";